import { render, staticRenderFns } from "./polymerization.vue?vue&type=template&id=7e0e654a&scoped=true"
import script from "./polymerization.vue?vue&type=script&lang=js"
export * from "./polymerization.vue?vue&type=script&lang=js"
import style0 from "./polymerization.vue?vue&type=style&index=0&id=7e0e654a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0e654a",
  null
  
)

export default component.exports